import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";
import { Service } from "../../../models/service";
import { Store } from "../../../services/store.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { TutorialBase } from "../../../models/tutorial-base";
import printJS from "print-js";

@Component({
  selector: "app-service-documentation",
  templateUrl: "./service-documentation.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class ServiceDocumentationComponent implements OnInit {

  public serviceId: string;
  public lng: any;
  public service: Service;
  public baseUrl: string;
  public loading: boolean = true;

  public registrations: any[] = [];
  public roles: any[] = [];
  public bots: any[] = [];
  public certificates: any[] = [];
  public guideForm: any;
  public applicantForm: any;
  public documentForm: any;
  public paymentForm: any;
  public sendFileForm: any;

  constructor(private serviceControllerService: ServiceControllerService,
              private route: ActivatedRoute,
              public translate: TranslateService,
              public store: Store,
  ) { }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/documentation";
      this.lng = this.store.state.common.lang;
      this.loadService();
    });
  }

  public printPage() {
    printJS({
      printable: document.getElementById("serviceTutorial").innerHTML,
      type: "raw-html",
      showModal: true,
      header: `${this.service.name} - ${this.translate.instant("Tutorials")}`,
      documentTitle: `${this.service.name} - ${this.translate.instant("Tutorials")}`,
      css: "/assets/styles/print-tutorials.css",
    });
  }

  public loadService() {
    this.loading = true;
    this.serviceControllerService.getServiceTutorials(this.serviceId).subscribe(
      (data: any) => {
        this.loading = false;
        this.service = data.service[0];
        this.service.tutorials = Object.assign(new TutorialBase().tutorials, this.service.tutorials);
        this.registrations = data.registrations.filter((r) => r.tutorials && Object.keys(r.tutorials).length).sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
        this.roles = data.roles.filter((r) => r.tutorials && Object.keys(r.tutorials).length).sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
        this.bots = data.bots.filter((r) => r.tutorials && Object.keys(r.tutorials).length).sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
        this.certificates = data.printDocuments.filter((r) => r.tutorials && Object.keys(r.tutorials).length).sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
        this.guideForm = data.guideForm && data.guideForm[0] && Object.keys(data.guideForm[0].tutorials).length ? data.guideForm[0] : null;
        this.applicantForm = data.applicantForm && data.applicantForm[0] && Object.keys(data.applicantForm[0].tutorials).length ? data.applicantForm[0] : null;
        this.documentForm = data.documentForm && data.documentForm[0] && Object.keys(data.documentForm[0].tutorials).length ? data.documentForm[0] : null;
        this.paymentForm = data.paymentForm && data.paymentForm[0] && Object.keys(data.paymentForm[0].tutorials).length ? data.paymentForm[0] : null;
        this.sendFileForm = data.sendFileForm && data.sendFileForm[0] && Object.keys(data.sendFileForm[0].tutorials).length ? data.sendFileForm[0] : null;
      },
    );
  }

  public jumpTo(e) {
    e.preventDefault();
    const target = document.querySelector(e.srcElement.attributes.href.value);
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - 222,
      behavior: "smooth",
    });
  }

  public checkGroup(group: any, lng) {
    return group && !this.checkValue(group[lng], lng);
  }

  public checkItems(items, lng) {
    return items.filter((item) => !this.checkValue(item.tutorials.general[lng], lng) ).length > 0;
  }

  public checkValue(v, lng) {
    if (!v) { return true; }
    return (this.service.tutorials.general[lng] && v === this.service.tutorials.general[lng]) || (v === "<p>...</p>")  || (v === "...") || (v.includes(this.translate.instant("From")) && v.includes("...") || v.length < 1 );
  }

}
